export default "__VITE_ASSET__Dfb6OGNY__ 640w, __VITE_ASSET__LvNsjMnl__ 1024w, __VITE_ASSET__D0BeILqo__ 1536w";